import CandidateProject, { CandidateProjectComponentProps } from './CandidateProject.component';
import ProfileInfoPreview, { ProfileInfoPreviewType } from '../ProfileInfoPreview';

export type CandidateProjectProps = CandidateProjectComponentProps &
  ProfileInfoPreviewType & {
    isEditing: boolean;
  };

export default function CandidateProjectContainer({
  isEditing,
  ...props
}: CandidateProjectProps): JSX.Element {
  const parsedSkills = props.skills.map((skill) => {
    return props.skillsOptions.find((option) => option.value === skill)?.label ?? '';
  });
  if (isEditing) {
    return <CandidateProject {...props} />;
  }
  return <ProfileInfoPreview {...props} skills={parsedSkills} detail={props.year} />;
}
